/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connectyoursocialmediaprofiles4Inputs */

const en_connectyoursocialmediaprofiles4 = /** @type {(inputs: Connectyoursocialmediaprofiles4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your social media profiles`)
};

const de_connectyoursocialmediaprofiles4 = /** @type {(inputs: Connectyoursocialmediaprofiles4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde deine Social-Media-Profile`)
};

/**
* | output |
* | --- |
* | "Connect your social media profiles" |
*
* @param {Connectyoursocialmediaprofiles4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const connectyoursocialmediaprofiles4 = /** @type {((inputs?: Connectyoursocialmediaprofiles4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connectyoursocialmediaprofiles4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_connectyoursocialmediaprofiles4(inputs)
	return de_connectyoursocialmediaprofiles4(inputs)
});
export { connectyoursocialmediaprofiles4 as "connectYourSocialMediaProfiles" }